enum Platform {
  Macintosh = 'Macintosh',
  IPhone = 'iPhone',
}

export enum AccountMode {
  PASSKEY = 'Passkey',
  PASSWORD = 'Password',
}

export const getHost = ({ key }: { key: string }) => {
  return key || window.location.host;
};

export const getCloudPlatform = (): 'iCloud' | 'GoogleCloud' => {
  const userAgent = window.navigator.userAgent;
  if (userAgent.includes(Platform.Macintosh) || userAgent.includes(Platform.IPhone))
    return 'iCloud';
  return 'GoogleCloud';
};

export const getPasskeyFile = (params: { key: string }) => {
  const userAgent = window.navigator.userAgent;
  const host = getHost(params);

  if (userAgent.includes(Platform.Macintosh) || userAgent.includes(Platform.IPhone))
    return btoa(`${host}/privateKey`);
  return btoa(`${host}/privateKey`);
};

export const getPasswordFile = (params: { key: string }) => {
  const userAgent = window.navigator.userAgent;
  const host = getHost(params);
  if (userAgent.includes(Platform.Macintosh) || userAgent.includes(Platform.IPhone))
    return btoa(`${host}/password`);
  return btoa(`${host}/password`);
};
export const getPrivateFile = ({ mode, key }: { mode: AccountMode; key: string }) => {
  switch (mode) {
    case AccountMode.PASSKEY:
      return getPasskeyFile({ key });
    case AccountMode.PASSWORD:
      return getPasswordFile({ key });
  }
};
export const parseJwt = (token: string) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
};
